import React from 'react'
import { T } from '@transifex/react'

import { pathJoin } from 'src/reducers/routing/utils'

import { createCustomersRouteMap } from './customers'
import { createOffersRoutesMap } from './offers'
import { createSqlDatasetsRouteMap } from './sql-datasets'

export const createControlCenterRoutesMap = (prefix: string) => ({
  leads: pathJoin(prefix)('leads').chainWithTitle({
    title: <T _str="Leads" />,
    breadCrumbTitle: <T _str="Leads" />,
  }),
  customers: pathJoin(prefix)('customers').chainMapAuto(
    createCustomersRouteMap,
    {
      title: <T _str="Customers" />,
      breadCrumbTitle: <T _str="Customers" />,
    }
  ),
  offers: pathJoin(prefix)('offers').chainMapAuto(createOffersRoutesMap, {
    title: <T _str="Offers" />,
    breadCrumbTitle: <T _str="Offers" />,
  }),
  'feature-flags': pathJoin(prefix)('feature-flags').chainWithTitle({
    title: <T _str="Feature flags" />,
    breadCrumbTitle: <T _str="Feature flags" />,
  }),
  'sql-datasets': pathJoin(prefix)('sql-datasets').chainMapAuto(
    createSqlDatasetsRouteMap,
    {
      title: <T _str="SQL datasets" />,
      breadCrumbTitle: <T _str="SQL datasets" />,
    }
  ),
  dashboards: pathJoin(prefix)('dashboards').chainWithTitle({
    title: <T _str="Dashboards" />,
    breadCrumbTitle: <T _str="Dashboards" />,
  }),
  'portal-rights': pathJoin(prefix)('portal-rights').chainWithTitle({
    title: <T _str="Portal role rights" />,
    breadCrumbTitle: <T _str="Portal role rights" />,
  }),
  'test-sockets': pathJoin(prefix)('test-sockets').chain,
  'error-test': pathJoin(prefix)('error-test').chain,
})
